// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"64f781eb","552":"fa269270","680":"f13be440","928":"5528c78e"}[chunkId] + ".chunk.js";
};